import { useState, useNavigate, useEffect } from '../../../common/common';
import Navigations from '../../../common/useNavigation.js';
import axiosJWT from '../../../secureAPI/axiosJWT.js';
import { StopLoading, StartLoading } from '../../../Utils/loadingUtils.js';
import { showToast } from '../../../Utils/toastUtils.js';
import useGetUserData from '../../../secureAPI/GetUserData';

const MidEditProductAttributes = () => {
    const navigate = useNavigate();

    const [isLoading, setisLoading] = useState(false);
    const [isDisabled, setisDisabled] = useState(false);
    const [getattributes, setAttributes] = useState([]);
    // const [values, setValues] = useState([]);
    const { navigateSellerProductAttributes } = Navigations();
    const [checkedIds, setCheckedIds] = useState([]);
    const [userProductAttributes, SetUserProductAttributes] = useState([]);
    const { users,userPlan,Remainuser,subUser } = useGetUserData();
    // uservalues
    const [values, setUserValue] = useState({
        isIndian: "",
        isPersonalDetails: "",
        primaryContact: "",
        emailnmobi: "",
        contactnumber: "",
        companyName: "",
        companyInitials: "",
        companyWebsite: "",
        companyGST: "",
        address1: "",
        address2: "",
        country: 101,
        state: 73,
        city: 12545,
        zipCode: "",
    });
    useEffect(() => {
        if (Array.isArray(users) && users.length > 0) {
            // console.log('useEffect called, users:', users);

            const currentUser = users[0];
            // console.log({ users: currentUser });

            if (currentUser['IsUserAttributes'] === 0 && currentUser['UserType'] === '1') {
                navigateSellerProductAttributes();
            } else {
                setUserValue(prevValues => ({
                    ...prevValues,
                    emailnmobi: currentUser['EmailAddress'],
                    primaryContact: currentUser['Mobile'],
                    isIndian: currentUser['IsIndian'],
                    isPersonalDetails: currentUser['IsPersonalDetils'],
                }));
            }
        }
    }, [users]); // Only users as dependency
    // useEffect(() => {
    //     if (Array.isArray(users) && users.length > 0) {
    //         console.log('useEffect called, users:', users);
    //         logUserData();
    //     }
    // }, [users]);
    // const logUserData = () => {
    //     console.log({ users: users })
    //     if (users?.length > 0) {

    //         if (users[0]['IsUserAttributes'] === 0 && (users[0]['UserType'] == '1')) {
    //             navigateSellerProductAttributes();
    //         }

    //         else {
    //             setUserValue({
    //                 ...values,
    //                 emailnmobi: users[0]['EmailAddress'],
    //                 primaryContact: users[0]['Mobile'],
    //                 isIndian: users[0]['IsIndian'],
    //                 isPersonalDetails: users[0]['IsPersonalDetils'],
    //             });

    //         }
    //     }
    // };


    useEffect(() => {
        // console.log({ userProductAttributes });
        setCheckedIds(userProductAttributes);
    }, [userProductAttributes]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                StartLoading(setisLoading, setisDisabled);

                // Fetch product attributes with 1 second delay
                setTimeout(async () => {
                    try {
                        await getProductAttributes();
                    } catch (error) {
                        console.error('Failed to fetch product attributes', error);
                    }
                }, 1000);

                // Fetch user product attributes
                await GetUserProductAttributes();

            } catch (error) {
                console.error('Error checking authentication status', error);
                // navigate('/', { replace: true });
            } finally {
                StopLoading(setisLoading);
            }
        };

        const GetUserProductAttributes = async () => {
            StartLoading(setisLoading);
            try {
                const { data } = await axiosJWT.post(
                    `${process.env.REACT_APP_API_URL}/api/GetUserProductAttributes`,
                    { data: { app: 0 } },
                    { withCredentials: true }
                );

                if (data.success === 1) {
                    const numbersArray = data.selectedArray[0].selected_attributes_id
                        .split(',')
                        .map(Number)
                        .filter(num => !isNaN(num));

                    SetUserProductAttributes(numbersArray);
                } else {
                    showToast(data.message, 'error');
                }
            } catch (err) {
                console.error('Error fetching user attributes:', err);
                showToast('Something went wrong! Please try again', 'error');
            }
        };

        fetchData();
    }, [navigate]); // Only navigate as dependency

    const getProductAttributes = async () => {
        try {
            const { data } = await axiosJWT.post(
                `${process.env.REACT_APP_API_URL}/api/GetProductAttributes`,
                { app: 0 },
                { withCredentials: true, credentials: 'include' }
            );
            handleProductAttributesResponse({ data });
        } catch (err) {
            handleProductAttributesError(err);
            throw err; // Re-throw to be caught in the useEffect
        }
    };
    // useEffect(() => {
    //     try {
    //         StartLoading(setisLoading, setisDisabled);
    //         setTimeout(async () => {
    //             try {
    //                 await getProductAttributes();  // Assuming this is defined elsewhere
    //             } catch (error) {
    //                 console.error('Failed to fetch product attributes', error);
    //             }
    //         }, 1000);

    //     } catch (error) {
    //         console.error('Error checking authentication status', error);
    //         // navigate('/', { replace: true });
    //     }
    //     const GetUserProductAttributes = async () => {
    //         StartLoading(setisLoading);
    //         const data = { app: 0 };
    //         await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetUserProductAttributes`, { data: data }, { withCredentials: true })
    //             .then((response) => {
    //                 StopLoading(setisLoading);
    //                 console.log('data awaiting');
    //                 console.log(response.data.selectedArray[0].selected_attributes_id);
    //                 if (response.data.success === 1) {
    //                     console.log('data awaiting 2');
    //                     console.log(response.data.data);
    //                     // SetUserProductAttributes(response.data.data.id);
    //                     // Extracting only the 'id' values
    //                     const numbersArray = response.data.selectedArray[0].selected_attributes_id.split(',').map(Number);

    //                     console.log(numbersArray);
    //                     // Set the ids array in the state
    //                     SetUserProductAttributes(numbersArray);
    //                     // SetDistributors(Array.isArray(userData) ? userData : [userData]);
    //                 }
    //                 else {
    //                     StopLoading(setisLoading);
    //                     showToast(response.data.message, 'error');
    //                 }
    //             })
    //             .catch((err) => {
    //                 StopLoading(setisLoading);
    //                 showToast('Somthing went wrong ! please try again ', 'error');
    //             });
    //     }
    //     GetUserProductAttributes();

    // }, [navigate]);

    // const getProductAttributes = async () => {
    //     try {
    //         StartLoading(setisLoading, setisDisabled);
    //         await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetProductAttributes`, { app: 0 }, { withCredentials: true, credentials: 'include' })
    //             .then(handleProductAttributesResponse)
    //             .catch(handleProductAttributesError);
    //     } catch (err) {
    //         console.error('Error fetching product attributes:', err);
    //     }
    // };
    const handleProductAttributesResponse = (res) => {
        const result = res.data;
        // console.log({ result: result });
        if (result.success === 1) {
            handleSuccessfulProductAttributes(result);
        } else {
            showToast(result.message, 'error');
        }

        StopLoading(setisLoading, setisDisabled);
    };
    const handleSuccessfulProductAttributes = (result) => {
        const { message, data } = result;
        // setUserid(1);
        setAttributes(data);
        // showToast(message, 'success');

    };
    const handleProductAttributesError = (err) => {
        console.error(err);
        showToast('Something went wrong! Please try again later', 'error');
        StopLoading(setisLoading, setisDisabled);
    };
    const removeOneOccurrence = (str) => {
        // Step 1: Use the replace method to remove only the first occurrence of "1,2,3"
        return str.replace('1,2,3', '').replace(/^,|,$/g, '');  // Also removes leading/trailing commas if needed
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        const sortedValues = [...checkedIds].sort((a, b) => a - b);
        const reducedString = sortedValues.reduce((acc, curr) => `${acc}${curr},`, '');
        const resultString = reducedString.replace(/,*$/, '');
        const Checkresult = removeOneOccurrence(resultString);
        insertuserattribute(Checkresult);
    };
    const insertuserattribute = async (resultString) => {

        try {
            StartLoading(setisLoading, setisDisabled);
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/SetProductAttributes`, { resultString, app: 0 }, { withCredentials: true, credentials: 'include' })
                .then(handleSetProductAttributesResponse)
                .catch(handleSetProductAttributesError);
        }
        catch (err) {
            console.error('Error submit product attributes:', err);
        }
    };

    const handleSetProductAttributesResponse = (res) => {
        const result = res.data;
        // console.log({ result: result });
        if (result.success === 1) {
            handleSuccessfulSetProductAttributes(result);
        } else {
            showToast(result.message, 'error');
        }

        StopLoading(setisLoading, setisDisabled);
    };

    const handleSuccessfulSetProductAttributes = (result) => {
        const { message } = result;
        showToast(message, 'success');
        // navigateSellerReorderProductAttributes();

    };
    const handleSetProductAttributesError = (err) => {
        console.error(err);
        showToast('Something went wrong! Please try again later', 'error');
        StopLoading(setisLoading, setisDisabled);
    };

    return { users,userPlan,Remainuser,subUser, getattributes, isLoading, isDisabled, handleSubmit, checkedIds, setCheckedIds, userProductAttributes }
}

export default MidEditProductAttributes